import React, { useEffect } from "react";
import ToggleButton from "../../../CommonComponents/ToggleButton";
import { getDataFromStorage } from "../../../../util";
import constants from "../../../../constants";
import QnCountField from "../../Tests/QnCountField";
import InputField from "../../../CommonComponents/InputField";
import InputDropdown from "../../../CommonComponents/InputDropdown";
import Table from "../../../CommonComponents/Table";
import Button from "../../../Button";
import IconButton from "../../../CommonComponents/IconButton";
import { nanoid } from "nanoid";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tooltip from "@mui/material/Tooltip";
import Textarea from "../../../CommonComponents/Textarea";

const QuestionConfiguration = ({
  types,
  currentType,
  handleReturnChange,
  parameters,
  setParameters,
  testcases,
  setTestCases,
  value,
  setValue,
  testDetails,
  setTestDetails,
  errors,
  setErrors,
  isPublished,
  onChange,
  onChangeTestCases,
}) => {
  const companyId = getDataFromStorage("companyId");
  const isGradiousUniversity =
    parseInt(companyId) === constants.GRADIOUS_ACCOUNT_ID;

  const onChangeField = (step, field, value) => {
    onChange && onChange(step, field, value);
  };
  const column = [
    {
      key: "Parameter Name",
      title: "Parameter Name",
      className: "Parameter Name",
    },
    {
      key: "Data Type",
      title: "Data Type",
      className: "Data Type",
    },
  ];

  useEffect(() => {
    setTestDetails((prev) => ({
      ...prev,
      functionparams: parameters,
    }));
  }, [parameters]);

  const renderRow = (row, rowIndex) => {
    // console.log("row:", row);
    return (
      <tr key={row.id}>
        <td style={{ padding: "8px" }}>
          <InputField
            value={row.parametername}
            placeholder="Enter parameter name"
            onChange={(e) =>
              onChangeField(row.id, "parametername", e.target.value)
            }
            hintText={errors?.functionparams?.[row.id]?.parametername}
            destructive={!!errors?.functionparams?.[row.id]?.parametername}
          />
        </td>

        <td style={{ display: "flex", gap: "24px", padding: "8px" }}>
          <InputDropdown
            value={row.parametertype}
            options={types}
            placeholder="Data Type"
            onChange={(value) => onChangeField(row.id, "parametertype", value)}
            hintText={errors?.functionparams?.[row.id]?.parametertype}
            destructive={!!errors?.functionparams?.[row.id]?.parametertype}
          />
          {row?.isdeletable ? (
            <IconButton
              size="md"
              hierarchy="secondaryGrey"
              destructive={true}
              onClick={() => deleteExistingParameters(row?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 4.99984H4.16667M4.16667 4.99984H17.5M4.16667 4.99984V16.6665C4.16667 17.1085 4.34226 17.5325 4.65482 17.845C4.96738 18.1576 5.39131 18.3332 5.83333 18.3332H14.1667C14.6087 18.3332 15.0326 18.1576 15.3452 17.845C15.6577 17.5325 15.8333 17.1085 15.8333 16.6665V4.99984H4.16667ZM6.66667 4.99984V3.33317C6.66667 2.89114 6.84226 2.46722 7.15482 2.15466C7.46738 1.8421 7.89131 1.6665 8.33333 1.6665H11.6667C12.1087 1.6665 12.5326 1.8421 12.8452 2.15466C13.1577 2.46722 13.3333 2.89114 13.3333 3.33317V4.99984M8.33333 9.1665V14.1665M11.6667 9.1665V14.1665"
                  stroke="#F04438"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </IconButton>
          ) : (
            <IconButton
              size="md"
              hierarchy="secondaryGrey"
              destructive={true}
              disabled={true}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 4.99984H4.16667M4.16667 4.99984H17.5M4.16667 4.99984V16.6665C4.16667 17.1085 4.34226 17.5325 4.65482 17.845C4.96738 18.1576 5.39131 18.3332 5.83333 18.3332H14.1667C14.6087 18.3332 15.0326 18.1576 15.3452 17.845C15.6577 17.5325 15.8333 17.1085 15.8333 16.6665V4.99984H4.16667ZM6.66667 4.99984V3.33317C6.66667 2.89114 6.84226 2.46722 7.15482 2.15466C7.46738 1.8421 7.89131 1.6665 8.33333 1.6665H11.6667C12.1087 1.6665 12.5326 1.8421 12.8452 2.15466C13.1577 2.46722 13.3333 2.89114 13.3333 3.33317V4.99984M8.33333 9.1665V14.1665M11.6667 9.1665V14.1665"
                  stroke="#F04438"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </IconButton>
          )}
        </td>
      </tr>
    );
  };

  const addNewParameters = () => {
    let newParameter;
    if (parameters.length >= 1) {
      newParameter = {
        id: nanoid(),
        parametername: "",
        parametertype: "",
        isdeletable: true,
      };
    } else {
      newParameter = {
        id: nanoid(),
        parametername: "",
        parametertype: "",
      };
    }
    setParameters((prev) => [...prev, newParameter]);
  };

  const deleteExistingParameters = (id) => {
    // console.log("parameterId:", id);

    let currLength = parameters.length;
    if (currLength === 1) {
      let newParameter = [
        { id: nanoid(), parametername: "", parametertype: "" },
      ];
      setParameters(newParameter);
      setTestDetails((prev) => ({
        ...prev,
        functionparams: newParameter,
        testcases: prev.testcases.map((test) => ({
          ...test,
          input: "",
          output: "",
        })),
      }));
      setTestCases((prev) =>
        prev.map((test) => ({
          ...test,
          input: "",
          output: "",
        })),
      );
    } else {
      const index = parameters.findIndex((para) => para.id === id);
      // console.log("index:", index);
      let updatedParameters = parameters.filter((para) => para.id !== id);
      setParameters(updatedParameters);
      setTestDetails((prev) => ({
        ...prev,
        functionparams: updatedParameters,
        testcases: prev.testcases.map((test) => ({
          ...test,
          input: test.input
            .split("\n")
            .filter((_, iIdx) => iIdx !== index)
            .join("\n"),
        })),
      }));
      setTestCases((prev) =>
        prev.map((test) => ({
          ...test,
          input: test.input
            .split("\n")
            .filter((_, iIdx) => iIdx !== index)
            .join("\n"),
        })),
      );
    }
  };

  const handleTabChange = (event, newValue) => {
    // console.log("event:", event, "newValue:", newValue);
    // console.log("testcases:", testcases);
    for (let i = 0; i < testcases.length; i++) {
      if (testcases[i].id === testcases[newValue].id) {
        testcases[i].isActive = true;
      } else {
        testcases[i].isActive = false;
      }
    }
    setValue(newValue);
  };

  useEffect(() => {
    console.log("testCases:", testcases);
  }, [testcases]);
  // useEffect(() => {
  //   console.log("errors;", errors);
  // }, [errors]);

  const addNewTestCases = () => {
    const newObj = {
      actualoutput: "",
      id: nanoid(),
      input: "",
      isActive: false,
      isExample: 0,
      output: "",
    };

    setTestCases((prev) => [...prev, newObj]);
    setTestDetails((prev) => ({
      ...prev,
      testcases: [...prev.testcases, newObj],
    }));
  };

  // const findAnyIncompleteFields = (index) => {
  //   const totalInputSize = parameters.length;
  //   let testCase = testcases.find((test, idx) => idx === index);
  //   console.log("testCassssssssssse:",testCase);
  //   console.log("testCase.input.split(\n).length !== totalInputSize:",testCase.input.split("\n").length !== totalInputSize);
  //   return testCase.input.split("\n").length !== totalInputSize;
  // };

  const deleteTestcase = (id) => {
    let tot = testcases.length;
    let index = testcases.findIndex((tc) => tc.id === id);
    setTestCases((prev) => prev.filter((tc) => tc.id !== id));
    setTestDetails((prev) => ({
      ...prev,
      testcases: prev.testcases.filter((tc) => tc.id !== id),
    }));
    if (index === 0) {
      if (tot <= 1) {
        setValue(0);
      } else {
        setValue((prev) => prev);
      }
    } else {
      setValue((prev) => prev - 1);
    }
  };

  const hasInputError = (errors, testcaseIndex, paramIndex) => {
    const inputErrors = errors?.testcases?.[testcaseIndex]?.input;
    if (!inputErrors || !Array.isArray(inputErrors)) return false;

    const error = inputErrors[paramIndex];
    return error && typeof error === "string" && error.trim().length > 0;
  };

  return (
    <div className="question-config-main-container">
      {isGradiousUniversity && (
        <ToggleButton
          text="Autoevaluate :"
          name="autoevaluate"
          pressed={!!testDetails?.autoevaluate}
          onChange={(checked) =>
            onChangeField(1, "autoevaluate", checked ? 1 : 0)
          }
          reverse
          disabled={isPublished}
        />
      )}
      <div className="question-config-section-1">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <p className="question-config-title">Maximum Time allowed (mins)</p>
          <QnCountField
            className="question-config"
            id="question-config"
            name="duration"
            value={testDetails?.duration}
            onChange={(event) =>
              onChangeField(1, event.target.name, event.target.value)
            }
            onClick={(value) => onChangeField(1, "duration", value)}
            destructive={!!errors.duration || !!errors?.qnsCount}
            disabled={isPublished}
          />
          <p className="config-duration-hint-text">{errors.duration}</p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <p className="question-config-title">Marks</p>
          <QnCountField
            className="question-config"
            id="question-config"
            name="marks"
            value={testDetails?.marks}
            destructive={!!errors.marks}
            onChange={(event) =>
              onChangeField(1, event.target.name, event.target.value)
            }
            onClick={(value) => onChangeField(1, "marks", value)}
            disabled={isPublished}
          />
          <p className="config-mark-hint-text">{errors.marks}</p>
        </div>
      </div>

      <div className="question-config-section-2">
        <div
          className={
            errors.returntype
              ? "question-config-section-2-functionname-error"
              : "question-config-section-2-functionname"
          }
        >
          <InputField
            label="Function Name*"
            name="functioname"
            value={testDetails.functionname}
            placeholder="Enter the function name"
            onChange={(event) =>
              onChangeField(1, "functionname", event.target.value)
            }
            hintText={errors?.functionname}
            destructive={!!errors?.functionname}
            disabled={isPublished}
          />
        </div>
        <div
          className={
            errors.functionname
              ? "question-config-section-2-returntype-error"
              : "question-config-section-2-returntype"
          }
        >
          <InputDropdown
            label="Return type*"
            placeholder="Select Return Type"
            options={types}
            hintText={errors?.returntype}
            destructive={!!errors?.returntype}
            value={testDetails?.returntype.value}
            name="returntype"
            onChange={(value) => {
              handleReturnChange(value);
              onChangeField(1, "returntype", value);
            }}
          />
        </div>
      </div>

      <div className="question-config-section-3">
        <p className="title">Parameter Details</p>
        <Table columns={column} renderRow={renderRow} data={parameters} />
        <div style={{ display: "flex", justifyContent: "end", width: "80%" }}>
          <Button
            size="sm"
            destructive={false}
            hierarchy={{
              type: "tertiaryGrey",
              buttonText: "Parameter",
            }}
            icon={{
              type: "leading",
              icon: (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66829 0.834961V12.5016M0.834961 6.66829H12.5016"
                    stroke="#667085"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
            }}
            className={"addParameters"}
            disable={
              parameters?.[parameters?.length - 1]?.parametername.trim() ===
                "" ||
              parameters?.[parameters?.length - 1]?.parametertype.trim() === ""
            }
            onClick={() => addNewParameters()}
          />
        </div>
      </div>

      <div className="question-config-section-4">
        <div className="codingOutputTestcasesDivBox">
          <Box
            sx={{
              overflowX: "auto",
              bgcolor: "background.paper",
              maxWidth: { xs: 320, sm: 900 },
              display: "flex",
              gap: "16px",
            }}
          >
            <Tabs
              variant="scrollable"
              scrollButtons={false}
              value={value}
              onChange={handleTabChange}
              className="codingOutputTestcasesDivBoxTab"
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              {testcases.map((tab, index) => (
                <Tab
                  key={index}
                  label={`Test Case ${index + 1}`}
                  className={`${
                    value === index
                      ? "codingOutputTab-active"
                      : "codingOutputTab-notactive"
                  }`}
                  icon={
                    <Tooltip title={"Example test case"} arrow>
                      <span
                        className={
                          tab?.isExample
                            ? "codingOutputTab-isexample"
                            : "codingOutputTab-notisexample"
                        }
                      ></span>
                    </Tooltip>
                  }
                  iconPosition="end"
                />
              ))}
            </Tabs>
            <IconButton
              size="sm"
              hierarchy="tertiaryGrey"
              destructive={false}
              onClick={() => addNewTestCases()}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66829 0.834961V12.5016M0.834961 6.66829H12.5016"
                  stroke="#E54B2A"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </IconButton>
          </Box>
        </div>

        <div className="testcase-parameter-container">
          {testcases.map((tab, index) => (
            <>
              <div className="testcase-parameters" hidden={value !== index}>
                <div className="testcase-parameters-content">
                  {parameters.map((input, ind) => (
                    <div
                      className={
                        hasInputError(errors, index, ind)
                          ? "testcase-parameters-input-error"
                          : "testcase-parameters-input"
                      }
                    >
                      <InputField
                        label={`${
                          input?.parametername.trim() !== "" &&
                          input?.isdeletable
                            ? `${input.parametername}`
                            : `Parameter ${ind + 1} Value`
                        }`}
                        name="parameter1value"
                        value={
                          testcases?.[index]?.input?.split("\n")?.[ind] ?? ""
                        }
                        placeholder="1"
                        onChange={(event) =>
                          onChangeTestCases(
                            index,
                            ind,
                            "input",
                            event.target.value,
                          )
                        }
                        hintText={
                          errors?.testcases?.[index]?.input?.[ind] ?? ""
                        }
                        destructive={!!errors?.testcases?.[index]?.input?.[ind]}
                        disabled={!input?.isdeletable}
                      />
                    </div>
                  ))}
                  <div
                    className={
                      errors?.testcases?.[index]?.output
                        ? "testcase-parameters-output-error"
                        : "testcase-parameters-output"
                    }
                  >
                    <Textarea
                      label="Output Value"
                      name="outputvalue"
                      value={testcases[index]?.output ?? ""}
                      placeholder="3"
                      onChange={(event) =>
                        onChangeTestCases(
                          index,
                          0,
                          "output",
                          event.target.value,
                        )
                      }
                      hintText={errors?.testcases?.[index]?.output ?? ""}
                      destructive={!!errors?.testcases?.[index]?.output ?? ""}
                      // disabled={findAnyIncompleteFields(index)}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <ToggleButton
                    name="isexample"
                    text="Enable as Example"
                    pressed={!!testDetails.testcases[index].isExample}
                    onChange={(checked) =>
                      onChangeTestCases(index, 0, "isExample", checked ? 1 : 0)
                    }
                    disabled={isPublished}
                  />
                  <Button
                    size="sm"
                    destructive={true}
                    hierarchy={{
                      type: "tertiaryGrey",
                      buttonText: "Delete",
                    }}
                    icon={{
                      type: "leading",
                      icon: (
                        <svg
                          width="17"
                          height="19"
                          viewBox="0 0 17 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.834961 4.16829H2.50163M2.50163 4.16829H15.835M2.50163 4.16829V15.835C2.50163 16.277 2.67722 16.7009 2.98978 17.0135C3.30234 17.326 3.72627 17.5016 4.16829 17.5016H12.5016C12.9437 17.5016 13.3676 17.326 13.6801 17.0135C13.9927 16.7009 14.1683 16.277 14.1683 15.835V4.16829H2.50163ZM5.00163 4.16829V2.50163C5.00163 2.0596 5.17722 1.63568 5.48978 1.32312C5.80234 1.01056 6.22627 0.834961 6.66829 0.834961H10.0016C10.4437 0.834961 10.8676 1.01056 11.1801 1.32312C11.4927 1.63568 11.6683 2.0596 11.6683 2.50163V4.16829M6.66829 8.33496V13.335M10.0016 8.33496V13.335"
                            stroke="#B42318"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ),
                    }}
                    className={"deletetestcase"}
                    onClick={() => deleteTestcase(testcases[index].id)}
                  />
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      <p className="isExample-error-text">
        {errors?.minExample?.minExample ?? ""}
      </p>
    </div>
  );
};

export default QuestionConfiguration;
